import React from 'react';
import { useTranslation } from 'react-i18next/';

import './Stakes.scss';
import { Stake } from 'src/interfaces/BetslipState';
import { formatAmountToFixed } from 'src/utils/utils';

interface StakeProps {
  permutationsCount: number,
  stake: Stake
}

function Stakes({ permutationsCount, stake }: StakeProps) {
  const { t } = useTranslation();

  return (
    <div className="stake-betline">
      <div className="stake-betline__stakes-container">
        <span className="stake-betline__per-bet">{ permutationsCount > 1 ? t('betslip.perBet') : t('betslip.stake') }</span>
        { stake && stake.stake && <span className="stake-betline__stake">{ formatAmountToFixed(+stake.stake, 100, true) }</span> }
      </div>
      {
        stake && stake.maximumProfit && <span className="stake-betline__profit">{
          `${  t('betslip.potProfit') }: ${
            formatAmountToFixed(+stake.maximumProfit, 100, true) }`
        }</span>
      }
    </div>
  );
}

export default Stakes;
